import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { BarChart3, Wallet, HandCoins } from "lucide-react";
import DashboardOverview from "@/components/DashboardOverview";
import ExpensesTab from "@/components/ExpensesTab";
import ReceivablesTab from "@/components/ReceivablesTab";

export default function FinanceTab({ refreshKey, onChange }) {
  return (
    <div data-testid="finance-tab">
      <div className="mb-4">
        <h2 className="text-xl font-bold display text-slate-900 flex items-center gap-2">
          <BarChart3 className="w-5 h-5 text-[#0b3a82]" /> Finanças
        </h2>
        <p className="text-slate-500 text-sm">
          Contas a receber, despesas e resumo financeiro da sua agência.
        </p>
      </div>

      <Tabs defaultValue="receivables">
        <TabsList className="bg-white border border-slate-200" data-testid="finance-subtabs">
          <TabsTrigger value="receivables" data-testid="subtab-receivables">
            <HandCoins className="w-4 h-4 mr-1.5" /> A receber
          </TabsTrigger>
          <TabsTrigger value="expenses" data-testid="subtab-expenses">
            <Wallet className="w-4 h-4 mr-1.5" /> Despesas
          </TabsTrigger>
          <TabsTrigger value="summary" data-testid="subtab-summary">
            <BarChart3 className="w-4 h-4 mr-1.5" /> Resumo
          </TabsTrigger>
        </TabsList>

        <TabsContent value="receivables" className="mt-5">
          <ReceivablesTab onChange={onChange} />
        </TabsContent>
        <TabsContent value="expenses" className="mt-5">
          <ExpensesTab onChange={onChange} />
        </TabsContent>
        <TabsContent value="summary" className="mt-5">
          <DashboardOverview key={refreshKey} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
